<template>
  <div class="AuthPage">
    <AuthController />
  </div>
</template>

<script>
import AuthController from '@/components/Auth/Controller'

export default {
  name: "AuthPage",
  components: {
    AuthController
  },
  data: () => ({

  }),
  created() {

  },
}
</script>

<style lang="scss" scoped>
</style>
